import ExcelJS from "exceljs";

/** Tên sheet dữ liệu — backend import đọc sheet này trước */
export const CUSTOMER_IMPORT_DATA_SHEET = "Danh sách";

const thinBorder = {
  top: { style: "thin", color: { argb: "FFD1D5DB" } },
  left: { style: "thin", color: { argb: "FFD1D5DB" } },
  bottom: { style: "thin", color: { argb: "FFD1D5DB" } },
  right: { style: "thin", color: { argb: "FFD1D5DB" } },
};

/** Cột dữ liệu khách hàng + 1 người liên hệ (bắt buộc khuyến nghị) + liên hệ 2 (tuỳ chọn) */
export const CUSTOMER_IMPORT_COLS = [
  {
    header: "Tên khách hàng",
    width: 28,
    required: true,
    format: "Văn bản",
    example: "Trường Tiểu học Hoa Sen",
    note: "Bắt buộc. Tên trường / trung tâm / khách hàng.",
    group: "customer",
  },
  {
    header: "Số điện thoại",
    width: 16,
    required: false,
    format: "Số, 9–11 ký tự",
    example: "0901234567",
    note: "SĐT chính của khách hàng (tuỳ chọn).",
    group: "customer",
  },
  {
    header: "Địa chỉ",
    width: 28,
    required: false,
    format: "Văn bản",
    example: "12 Nguyễn Huệ",
    note: "Số nhà, đường (tuỳ chọn).",
    group: "customer",
  },
  {
    header: "Phường/Xã",
    width: 18,
    required: false,
    format: "Văn bản",
    example: "Bến Nghé",
    note: "Phường / xã theo địa bàn mới (tuỳ chọn).",
    group: "customer",
  },
  {
    header: "Nguồn khách",
    width: 16,
    required: false,
    format: "Facebook / Website / TikTok / Referral / Event",
    example: "Referral",
    note: "Mặc định = Referral (Giới thiệu) nếu để trống.",
    group: "customer",
  },
  {
    header: "Loại khách hàng",
    width: 16,
    required: false,
    format: "Trường học / Trung tâm / Khác",
    example: "Trường học",
    note: "Mặc định = Khác nếu để trống.",
    group: "customer",
  },
  {
    header: "Cấp học",
    width: 14,
    required: false,
    format: "Mầm non / Tiểu học / THCS / THPT",
    example: "Tiểu học",
    note: "Bắt buộc khi Loại = Trường học.",
    group: "customer",
  },
  {
    header: "Số học sinh",
    width: 12,
    required: false,
    format: "Số nguyên ≥ 0",
    example: "850",
    note: "Quy mô học sinh ước tính (tuỳ chọn).",
    group: "customer",
  },
  {
    header: "Trạng thái",
    width: 14,
    required: false,
    format: "new / active / idle / lost (hoặc tiếng Việt)",
    example: "new",
    note: "Mặc định = new (Mới). Có thể ghi: Mới, Đang chăm sóc…",
    group: "customer",
  },
  {
    header: "Ghi chú",
    width: 24,
    required: false,
    format: "Văn bản tự do",
    example: "Khách tiềm năng khu vực Q.1",
    note: "Ghi chú nội bộ CRM (tuỳ chọn).",
    group: "customer",
  },
  {
    header: "Họ tên người liên hệ",
    width: 22,
    required: false,
    format: "Văn bản",
    example: "Nguyễn Thị Lan",
    note: "Khuyến nghị nhập ít nhất 1 người liên hệ.",
    group: "contact1",
  },
  {
    header: "Chức vụ người liên hệ",
    width: 18,
    required: false,
    format: "Văn bản",
    example: "Hiệu trưởng",
    note: "Chức vụ tại trường / trung tâm.",
    group: "contact1",
  },
  {
    header: "SĐT người liên hệ",
    width: 16,
    required: false,
    format: "Số điện thoại",
    example: "0912345678",
    note: "SĐT người liên hệ chính.",
    group: "contact1",
  },
  {
    header: "Họ tên người liên hệ 2",
    width: 22,
    required: false,
    format: "Văn bản",
    example: "Trần Văn Bình",
    note: "Người liên hệ thứ 2 (tuỳ chọn).",
    group: "contact2",
  },
  {
    header: "Chức vụ người liên hệ 2",
    width: 18,
    required: false,
    format: "Văn bản",
    example: "Phó hiệu trưởng",
    note: "Tuỳ chọn.",
    group: "contact2",
  },
  {
    header: "SĐT người liên hệ 2",
    width: 16,
    required: false,
    format: "Số điện thoại",
    example: "0987654321",
    note: "Tuỳ chọn.",
    group: "contact2",
  },
];

const DATA_ENTRY_ROWS = 150;
const LEAD_LIST = '"Facebook,Website,TikTok,Referral,Event,Giới thiệu,Workshop"';
const TYPE_LIST = '"Trường học,Trung tâm,Khác"';
const LEVEL_LIST = '"Mầm non,Tiểu học,THCS,THPT"';
const STATUS_LIST =
  '"new,active,idle,lost,Mới,Đang chăm sóc,Không tương tác,Mất khách"';

function styleTitleCell(cell, { size = 15, color = "FF7F1D1D", bg = "FFFEE2E2" } = {}) {
  cell.font = { bold: true, size, color: { argb: color } };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
  cell.border = thinBorder;
}

function styleSectionTitle(cell) {
  cell.font = { bold: true, size: 12, color: { argb: "FFB91C1C" } };
  cell.alignment = { vertical: "middle", wrapText: true };
}

function styleBodyCell(cell, { bold = false, italic = false, bg = null } = {}) {
  cell.font = { size: 11, bold, italic, color: { argb: "FF374151" } };
  cell.alignment = { vertical: "top", wrapText: true };
  if (bg) {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  }
  cell.border = thinBorder;
}

function headerFillForGroup(group) {
  if (group === "contact1") return "FF0369A1";
  if (group === "contact2") return "FF0F766E";
  return "FFB91C1C";
}

function buildGuideSheet(wb) {
  const ws = wb.addWorksheet("Hướng dẫn", {
    views: [{ state: "frozen", ySplit: 1 }],
    properties: { defaultRowHeight: 18 },
  });
  const ncol = 6;
  ws.columns = [
    { width: 4 },
    { width: 26 },
    { width: 12 },
    { width: 36 },
    { width: 22 },
    { width: 48 },
  ];

  let r = 1;
  ws.mergeCells(r, 1, r, ncol);
  const t = ws.getCell(r, 1);
  t.value = "HƯỚNG DẪN IMPORT KHÁCH HÀNG (CRM)";
  styleTitleCell(t);
  ws.getRow(r).height = 36;
  r += 1;

  ws.mergeCells(r, 1, r, ncol);
  const sub = ws.getCell(r, 1);
  sub.value =
    "IMA Vietnam ERP — Nhập hàng loạt khách hàng / trường học. Phiên bản biểu mẫu: 2026.";
  sub.font = { italic: true, size: 10, color: { argb: "FF6B7280" } };
  sub.alignment = { horizontal: "center", wrapText: true };
  r += 2;

  const addSection = (title, lines) => {
    ws.mergeCells(r, 1, r, ncol);
    const c = ws.getCell(r, 1);
    c.value = title;
    styleSectionTitle(c);
    ws.getRow(r).height = 22;
    r += 1;
    for (const line of lines) {
      ws.mergeCells(r, 1, r, ncol);
      const lc = ws.getCell(r, 1);
      lc.value = line;
      styleBodyCell(lc);
      ws.getRow(r).height = line.length > 90 ? 38 : 20;
      r += 1;
    }
    r += 1;
  };

  addSection("I. QUY TRÌNH TRÊN HỆ THỐNG", [
    "Bước 1 — Mở «Quản lý khách hàng» → «Nhập excel».",
    "Bước 2 — Chọn Chi nhánh import (gán cho toàn bộ dòng trong file).",
    "Bước 3 — Nhập liệu trên sheet «Danh sách» (mỗi dòng = 1 khách hàng + người liên hệ).",
    "Bước 4 — Lưu file .xlsx và tải lên hệ thống.",
    "Bước 5 — Hệ thống tạo khách hàng; nếu có Họ tên người liên hệ thì lưu thêm vào danh sách người liên hệ.",
  ]);

  addSection("II. CÁCH NHẬP SHEET «DANH SÁCH»", [
    "• Dòng 1 là tiêu đề — KHÔNG xoá, KHÔNG đổi tên cột (có thể giữ dấu *).",
    "• Nhập từ dòng 2. Dòng trống (không có Tên khách hàng) sẽ bỏ qua.",
    "• Cột đỏ = thông tin khách hàng; xanh dương = người liên hệ 1; xanh lục = người liên hệ 2.",
    "• Khuyến nghị: mỗi khách hàng có ít nhất 1 người liên hệ (Họ tên + SĐT).",
    "• Khi Loại khách hàng = «Trường học» thì phải điền Cấp học.",
    "• Không gộp ô, không chèn dòng phía trên tiêu đề.",
  ]);

  ws.mergeCells(r, 1, r, ncol);
  ws.getCell(r, 1).value = "III. BẢNG MÔ TẢ CỘT";
  styleSectionTitle(ws.getCell(r, 1));
  ws.getRow(r).height = 22;
  r += 1;

  const hdr = ws.getRow(r);
  ["STT", "Tên cột", "Bắt buộc", "Định dạng / Giá trị", "Ví dụ", "Ghi chú"].forEach(
    (label, idx) => {
      const c = hdr.getCell(idx + 1);
      c.value = label;
      c.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
      c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFB91C1C" } };
      c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      c.border = thinBorder;
    }
  );
  hdr.height = 26;
  r += 1;

  CUSTOMER_IMPORT_COLS.forEach((col, idx) => {
    const row = ws.getRow(r);
    const vals = [
      idx + 1,
      col.required ? `${col.header} *` : col.header,
      col.required ? "Có" : "Không",
      col.format,
      col.example,
      col.note,
    ];
    vals.forEach((val, ci) => {
      const c = row.getCell(ci + 1);
      c.value = val;
      styleBodyCell(c, { bg: idx % 2 === 0 ? "FFF9FAFB" : "FFFFFFFF" });
      c.alignment = {
        vertical: "top",
        wrapText: true,
        horizontal: ci === 0 ? "center" : "left",
      };
    });
    row.height = 40;
    r += 1;
  });
  r += 1;

  addSection("IV. VÍ DỤ", [
    "Trường Tiểu học Hoa Sen | 0901234567 | 12 Nguyễn Huệ | Bến Nghé | Referral | Trường học | Tiểu học | 850 | new | … | Nguyễn Thị Lan | Hiệu trưởng | 0912345678 | …",
    "Trung tâm Ánh Dương | 0918765432 | 45 Lê Lợi | Võ Thị Sáu | Facebook | Trung tâm | (trống) | (trống) | active | … | Trần Văn Nam | Giám đốc | 0988111222 | …",
  ]);

  addSection("V. LƯU Ý", [
    "• Hệ thống đọc sheet «Danh sách» (không đọc sheet Hướng dẫn).",
    "• Chi nhánh lấy từ màn hình import, không nhập trong file.",
    "• Người liên hệ chỉ được tạo khi có Họ tên (SĐT / chức vụ có thể trống).",
    "• File CSV cũ vẫn import được, nhưng khuyến nghị dùng mẫu .xlsx này.",
  ]);

  return ws;
}

function buildDataSheet(wb) {
  const ws = wb.addWorksheet(CUSTOMER_IMPORT_DATA_SHEET, {
    views: [{ state: "frozen", ySplit: 1 }],
  });

  const headers = CUSTOMER_IMPORT_COLS.map((c) =>
    c.required ? `${c.header} *` : c.header
  );
  const headerRow = ws.getRow(1);
  headers.forEach((h, idx) => {
    const col = idx + 1;
    const meta = CUSTOMER_IMPORT_COLS[idx];
    const cell = headerRow.getCell(col);
    cell.value = h;
    cell.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: headerFillForGroup(meta.group) },
    };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = thinBorder;
    ws.getColumn(col).width = meta.width;
  });
  headerRow.height = 34;
  ws.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: CUSTOMER_IMPORT_COLS.length },
  };

  // 2 dòng mẫu
  const sample1 = [
    "Trường Tiểu học Hoa Sen",
    "0901234567",
    "12 Nguyễn Huệ",
    "Bến Nghé",
    "Referral",
    "Trường học",
    "Tiểu học",
    850,
    "new",
    "Khách hàng tiềm năng",
    "Nguyễn Thị Lan",
    "Hiệu trưởng",
    "0912345678",
    "Trần Văn Bình",
    "Phó hiệu trưởng",
    "0987654321",
  ];
  const sample2 = [
    "Trung tâm Kỹ năng Ánh Dương",
    "0918765432",
    "45 Lê Lợi",
    "Võ Thị Sáu",
    "Facebook",
    "Trung tâm",
    "",
    "",
    "active",
    "Đã làm việc sơ bộ",
    "Lê Minh Châu",
    "Giám đốc",
    "0909888777",
    "",
    "",
    "",
  ];

  [sample1, sample2].forEach((vals, i) => {
    const row = ws.getRow(i + 2);
    vals.forEach((val, ci) => {
      const cell = row.getCell(ci + 1);
      cell.value = val;
      cell.font = { size: 11, color: { argb: "FF1F2937" } };
      cell.border = thinBorder;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFBEB" },
      };
      cell.alignment = { vertical: "middle", wrapText: true };
    });
    row.height = 22;
  });

  for (let i = 0; i < DATA_ENTRY_ROWS; i += 1) {
    const rowNum = i + 4;
    const row = ws.getRow(rowNum);
    for (let c = 1; c <= CUSTOMER_IMPORT_COLS.length; c += 1) {
      const cell = row.getCell(c);
      cell.border = thinBorder;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFF7ED" },
      };
    }
  }

  // Data validation dropdowns
  const leadCol = CUSTOMER_IMPORT_COLS.findIndex((c) => c.header === "Nguồn khách") + 1;
  const typeCol =
    CUSTOMER_IMPORT_COLS.findIndex((c) => c.header === "Loại khách hàng") + 1;
  const levelCol = CUSTOMER_IMPORT_COLS.findIndex((c) => c.header === "Cấp học") + 1;
  const statusCol = CUSTOMER_IMPORT_COLS.findIndex((c) => c.header === "Trạng thái") + 1;

  const addList = (colIdx, formulae) => {
    if (colIdx < 1) return;
    for (let row = 2; row <= DATA_ENTRY_ROWS + 3; row += 1) {
      ws.getCell(row, colIdx).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [formulae],
        showErrorMessage: true,
        errorTitle: "Giá trị không hợp lệ",
        error: "Chọn giá trị trong danh sách gợi ý.",
      };
    }
  };

  addList(leadCol, LEAD_LIST);
  addList(typeCol, TYPE_LIST);
  addList(levelCol, LEVEL_LIST);
  addList(statusCol, STATUS_LIST);

  return ws;
}

/**
 * Tạo file mẫu Excel import khách hàng (blob sẵn để tải xuống).
 */
export async function buildCustomerImportTemplateBlob() {
  const wb = new ExcelJS.Workbook();
  wb.creator = "IMA Vietnam ERP";
  wb.created = new Date();
  buildGuideSheet(wb);
  buildDataSheet(wb);

  const buffer = await wb.xlsx.writeBuffer();
  return new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}

export async function downloadCustomerImportTemplate() {
  const blob = await buildCustomerImportTemplateBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "mau_import_khach_hang.xlsx";
  a.click();
  URL.revokeObjectURL(url);
}
